import type { DealConstructionContext } from "~/models/DealConstruction";
import { ConstructionActions } from "./ConstructionActions";
import { ConstructionAmounts } from "./ConstructionAmounts";
import Styles from "./ConstructionTop.module.scss";

type Props = {
	billingTarget?: "owner" | "rentee" | null;
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader?: DealConstructionContext | null;
	dealEstimationHistoryContext?: DealConstructionContext | null;
	estimationAddDisabled?: boolean;
	handleClickChangeAmount?: (() => void) | null;
	handleClickCreateHeader?: (() => void) | null;
	handleClickDestroyHeader?: (() => void) | null;
	handleClickEstimationHistoryPreview?: (() => void) | null;
	handleClickEstimationPreview?: (() => void) | null;
	handleClickGenerateBillings?: (() => void) | null;
	handleClickShowAddModal?: (() => void) | null;
	ownManagement?: boolean;
	readonly: boolean;
	showSubtotal?: boolean;
};

export function ConstructionTop({
	readonly,
	constructionContext,
	dealEstimationHistoryContext = null,
	dealEstimationDraftHeader = null,
	handleClickEstimationPreview = null,
	handleClickEstimationHistoryPreview = null,
	handleClickShowAddModal = null,
	handleClickChangeAmount = null,
	handleClickGenerateBillings = null,
	handleClickCreateHeader = null,
	handleClickDestroyHeader = null,
	billingTarget = null,
	estimationAddDisabled = false,
	ownManagement = false,
	showSubtotal = false
}: Props) {
	return (
		<div className={Styles.EstimateTop}>
			<ConstructionAmounts
				billingTarget={billingTarget}
				constructionContext={constructionContext}
				dealEstimationHistoryContext={dealEstimationHistoryContext}
				ownManagement={ownManagement}
				showSubtotal={showSubtotal}
			/>
			<ConstructionActions
				billingTarget={billingTarget}
				constructionContext={constructionContext}
				dealEstimationDraftHeader={dealEstimationDraftHeader}
				dealEstimationHistoryContext={dealEstimationHistoryContext}
				estimationAddDisabled={estimationAddDisabled}
				handleClickChangeAmount={handleClickChangeAmount}
				handleClickCreateHeader={handleClickCreateHeader}
				handleClickDestroyHeader={handleClickDestroyHeader}
				handleClickEstimationHistoryPreview={
					handleClickEstimationHistoryPreview
				}
				handleClickEstimationPreview={handleClickEstimationPreview}
				handleClickGenerateBillings={handleClickGenerateBillings}
				handleClickShowAddModal={handleClickShowAddModal}
				ownManagement={ownManagement}
				readonly={readonly}
			/>
		</div>
	);
}
